import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";

import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import {AddLessonSuccessResponse} from "../../types/lessons/add-lessons/addLessonsSchema";

import {setError} from "../../slice/addLessonSlice";


export const fetchAddLesson = createAsyncThunk(
    'lessons/addLesson',
    async (formData: FormData, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error('No token found in localStorage.');
            }
            const {token} = JSON.parse(authToken);
            const response = await axios.post<AddLessonSuccessResponse>(
                '/api/lessons',
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data.success) {
                thunkAPI.dispatch(setError(response.data));
                return response.data;
            } else {
                thunkAPI.dispatch(setError(response.data));
                throw new Error('Ошибка сохранения урока.');
            }
        } catch (error) {
            console.error('Произошла ошибка:', error);
            throw error;
        }
    }
);


